import React from "react";
import { connect } from "react-redux";
import SpinnerPadrao from "./SpinnerPadrao";

function LoadingScreen({ loading, opacity, noSpinner, msg, ...props }) {
    if (!loading)
        return <></>;

    return <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: props.tema.isDark ? !!opacity ? `rgba(48,48,48,${opacity})` : "#303030" : !!opacity ? `rgba(255,255,255,${opacity})` : "#fff", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}>
        {!noSpinner ? <SpinnerPadrao /> : <>{msg || <p style={{ fontWeight: "bold", fontSize: "1.2em", color: props.tema.isDark ? "#fff" : "#333" }}>Carregando...</p>}</>}
    </div>;

}

const mapStateToProps = (state) => {
    return { tema: state.tema };
};

export default connect(mapStateToProps, {})(LoadingScreen);